/** Gets pre-configured headers for all HTTP requests.
 *
 * @returns HTTP headers
 * @constant
 */
export const getDefaultHeaders = (accessToken) => {
    const res = {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
    };
    if (accessToken && accessToken.length > 10) {
        res.Authorization = `Bearer ${accessToken}`;
    }
    return res;
};
